import { createBrowserHistory } from 'history'

import { HomeroomHistory } from 'app2/views/shared-public/page/HomeroomHistory'

import { routes } from './routes'

export const history = new HomeroomHistory(createBrowserHistory(), routes);
